import VendorDirectory from "@/components/VendorDirectory";

export default function Vendors() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="vendors-page">
      <div className="mb-8">
        <p className="text-sm text-stone-600 font-semibold tracking-wide uppercase">Community directory</p>
        <h1 className="text-3xl sm:text-4xl font-black text-forest mt-1">Local vendors & tutors</h1>
        <p className="text-forest/60 mt-1">Trusted, admin-approved providers for your homeschooling journey.</p>
      </div>
      <VendorDirectory />
    </div>
  );
}
